module.exports = __webpack_public_path__ + "img/coconut-app-img.b49fbe83.jpg";